import { useEffect, useState } from "react";
import { Clock, ExternalLink, X } from "lucide-react";
import { api } from "../lib/api";

const fmtD = (s) => (s ? new Date(s).toLocaleDateString("it-IT") : "—");

export default function ClosingTimeModal({ params, onClose }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/closing-time/details", { params }).then(({ data }) => setData(data)).catch(() => setData({ items: [], n: 0 })); }, [params]);
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-3" onClick={onClose} data-testid="closing-time-modal">
      <div className="athanor-card max-h-[90vh] w-full max-w-4xl overflow-hidden p-0" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between border-b border-zinc-800/70 px-5 py-4">
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-full border border-[#C5A059]/30 bg-[#C5A059]/10"><Clock className="h-4 w-4 text-[#C5A059]" /></span>
            <div>
              <h3 className="text-base font-semibold text-slate-100">Contratti chiusi nel periodo</h3>
              <p className="text-xs text-slate-500">{data ? `${data.n} chiusi · media ${data.avg_days ?? "—"} giorni${data.min_days != null ? ` · min ${data.min_days} · max ${data.max_days}` : ""}` : "Carico…"}</p>
            </div>
          </div>
          <button onClick={onClose} data-testid="closing-time-modal-close" className="rounded-md p-2 text-slate-400 hover:bg-zinc-800"><X className="h-4 w-4" /></button>
        </div>
        <div className="max-h-[70vh] overflow-auto px-5 py-3">
          {data && data.items.length === 0 ? (
            <p className="py-10 text-center text-sm text-slate-500" data-testid="closing-time-empty">Nessun contratto chiuso nel periodo selezionato.</p>
          ) : (
            <table className="w-full text-sm">
              <thead className="sticky top-0 bg-[#111112]">
                <tr className="text-left text-xs text-slate-500">
                  <th className="pb-2 pr-2">Lead</th><th className="pb-2 pr-2">Venditore</th><th className="hidden pb-2 pr-2 md:table-cell">Pipeline</th>
                  <th className="pb-2 pr-2">Arrivato</th><th className="pb-2 pr-2">Chiuso</th><th className="pb-2 pr-2">Stage attuale</th><th className="pb-2 pr-2 text-right">Giorni</th><th className="hidden pb-2 text-right md:table-cell">Valore</th>
                </tr>
              </thead>
              <tbody>
                {(data?.items || []).map((i) => (
                  <tr key={i.opportunity_id} className="border-t border-zinc-800/50" data-testid={`closed-row-${i.opportunity_id}`}>
                    <td className="py-2 pr-2 text-slate-200">{i.link ? <a href={i.link} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 hover:text-[#C5A059]">{i.name}<ExternalLink className="h-3 w-3 opacity-60" /></a> : i.name}</td>
                    <td className="py-2 pr-2 text-slate-300">{i.seller}</td>
                    <td className="hidden py-2 pr-2 text-slate-400 md:table-cell">{i.pipeline}</td>
                    <td className="py-2 pr-2 tabular-nums text-slate-400">{fmtD(i.created_at)}</td>
                    <td className="py-2 pr-2 tabular-nums text-slate-400">{fmtD(i.won_at)}</td>
                    <td className="py-2 pr-2 text-slate-300" data-testid={`closed-stage-${i.opportunity_id}`}>{i.stage}<span className="block text-xs text-slate-500">{i.stage_since ? `dal ${fmtD(i.stage_since)}` : ""}</span></td>
                    <td className="py-2 pr-2 text-right tabular-nums font-semibold text-slate-100">{i.days ?? "—"}</td>
                    <td className="hidden py-2 text-right tabular-nums text-slate-300 md:table-cell">€{Number(i.value || 0).toLocaleString("it-IT")}</td>
                  </tr>
                ))}
              </tbody>
              {data && data.n > 0 && (
                <tfoot><tr className="border-t border-[#C5A059]/40 text-sm">
                  <td colSpan={6} className="py-2.5 font-medium text-slate-200">Media di tutti i chiusi ({data.n})</td>
                  <td className="py-2.5 text-right tabular-nums text-lg font-bold text-[#C5A059]" data-testid="closing-time-modal-avg">{data.avg_days ?? "—"}</td>
                  <td className="hidden py-2.5 text-right tabular-nums text-slate-300 md:table-cell">€{data.items.reduce((a, b) => a + Number(b.value || 0), 0).toLocaleString("it-IT")}</td>
                </tr></tfoot>
              )}
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
